"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var tool_icons_1 = require("./tool-icons");
var utils_1 = require("./utils");
var toolbar_1 = require("@syl-editor/lib/dist/lib/modules/toolbar");
var base_1 = require("./base");
var button_1 = require("./button");
var utils_2 = require("../utils");
var isMatchObject = function (objStatic, objCompare) {
    if (objStatic === objCompare)
        return true;
    if (!(objStatic && typeof objStatic === 'object') ||
        !(objCompare && typeof objCompare === 'object')) {
        return false;
    }
    var isArray = Array.isArray(objStatic);
    if (Array.isArray(objCompare) !== isArray)
        return false;
    if (isArray) {
        if (objStatic.length !== objCompare.length)
            return false;
        for (var i = 0; i < objStatic.length; i++) {
            if (!isMatchObject(objStatic[i], objCompare[i]))
                return false;
        }
    }
    else {
        for (var p in objStatic) {
            if (!(p in objCompare) || !isMatchObject(objStatic[p], objCompare[p])) {
                return false;
            }
        }
    }
    return true;
};
var SelectForToolbar = /** @class */ (function (_super) {
    __extends(SelectForToolbar, _super);
    function SelectForToolbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isActive = false;
        _this.activeIdx = -1;
        _this.checkActive = function () {
            var value = _this.props.toolbar.value;
            _this.activeIdx = value.findIndex(function (_a) {
                var attrs = _a.attrs;
                return isMatchObject(attrs, _this.attrs);
            });
            var needActive = value[_this.activeIdx] && value[_this.activeIdx].needActive;
            // 值为false需要高亮，相当于默认值需要高亮
            if (!_this.attrs) {
                if (needActive)
                    return true;
                else {
                    _this.activeIdx = -1;
                    return false;
                }
            }
            // select第一位认为是默认值
            if (!_this.activeIdx &&
                (needActive || _this.props.type === toolbar_1.TOOL_TYPE.DROPDOWN)) {
                return true;
            }
            else if (_this.activeIdx > 0) {
                return true;
            }
            return false;
        };
        _this.renderIcon = function () {
            var _a = _this.props, type = _a.type, display = _a.display, toolbar = _a.toolbar;
            var icon = type === toolbar_1.TOOL_TYPE.SELECT
                ? _this.renderSelectIcon()
                : _this.renderDropDownIcon();
            if (display === utils_2.ToolDisplay.HORIZON && toolbar.showName) {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    icon,
                    react_1.default.createElement("span", { className: "tool-name" }, toolbar.showName)));
            }
            return icon;
        };
        _this.renderSelectIcon = function () {
            var _a = _this.props, toolbar = _a.toolbar, editor = _a.editor, toolbarType = _a.toolbarType;
            var index = Math.max(0, _this.activeIdx);
            var value = toolbar.value[index];
            if (typeof toolbar.icon === 'function') {
                return toolbar.icon(editor, _this.attrs, { toolbarType: toolbarType });
            }
            return _this.renderMenuItem(value, _this.activeIdx) || _this.defaultIcon;
        };
        _this.renderDropDownIcon = function () { return _this.defaultIcon; };
        _this.renderMenuItem = function (value, idx) {
            if (idx === void 0) { idx = 0; }
            if (value.render) {
                return value.render({ toolbarType: _this.props.toolbarType });
            }
            else if (value.icon !== undefined) {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    value.icon,
                    react_1.default.createElement("span", { className: "tool-name" }, value.text)));
            }
            else if (value.text !== undefined) {
                return react_1.default.createElement("span", { className: "tool-name" }, value.text);
            }
            else if (tool_icons_1.Icons[_this.props.name] && tool_icons_1.Icons[_this.props.name][idx]) {
                return tool_icons_1.Icons[_this.props.name][idx];
            }
        };
        _this.menuItemClick = function (attrs) {
            _this.closeMenu();
            _this.props.handler(_this.props.editor, _this.props.name, attrs);
        };
        _this.renderMenu = function () {
            var _a = _this.props, value = _a.toolbar.value, _b = _a.toolbarType, toolbarType = _b === void 0 ? 'static' : _b;
            return value.map(function (v, index) {
                var _a;
                return (react_1.default.createElement(utils_1.ListItem, { className: classnames_1.default((_a = {
                            active: index === _this.activeIdx
                        },
                        _a[toolbarType] = toolbarType,
                        _a)), key: JSON.stringify(v.attrs), onClick: function () { return _this.menuItemClick(v.attrs); } }, _this.renderMenuItem(v, index)));
            });
        };
        return _this;
    }
    SelectForToolbar.prototype.componentDidMount = function () {
        this.props.editor.configurator.on(this.props.groupKey + "-close", this.closeMenu);
    };
    SelectForToolbar.prototype.componentWillUnmount = function () {
        this.props.editor.configurator.off(this.props.groupKey + "-close", this.closeMenu);
    };
    Object.defineProperty(SelectForToolbar.prototype, "attrs", {
        get: function () {
            var _a = this.props, getAttrs = _a.toolbar.getAttrs, attrs = _a.attrs, editor = _a.editor;
            return getAttrs ? getAttrs(editor) : attrs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectForToolbar.prototype, "defaultIcon", {
        get: function () {
            var _a = this.props, icon = _a.toolbar.icon, name = _a.name, type = _a.type, editor = _a.editor;
            if (icon) {
                if (typeof icon === 'function')
                    return icon(editor, this.attrs);
                return icon;
            }
            var Icon = tool_icons_1.Icons[name];
            if (type === toolbar_1.TOOL_TYPE.SELECT) {
                return Icon && Icon[0];
            }
            return Icon;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectForToolbar.prototype, "showName", {
        get: function () {
            return button_1.getConfigVal([this.props.showName, this.props.toolbar.showName]);
        },
        enumerable: true,
        configurable: true
    });
    return SelectForToolbar;
}(base_1.SelectBase));
exports.SelectForToolbar = SelectForToolbar;
//# sourceMappingURL=select.js.map